module.exports = __webpack_public_path__ + "public/img/icon_tuiguangfeny.14936f52.png";